import { useEffect, useRef, useState } from "react";

/* Detect if user prefers reduced motion — if so, skip animations */
const prefersReducedMotion =
  typeof window !== "undefined" &&
  window.matchMedia("(prefers-reduced-motion: reduce)").matches;

/**
 * useInView — fires once when element enters the viewport.
 * Returns [ref, inView].
 */
const useInView = ({ threshold = 0.12 } = {}) => {
  const ref = useRef(null);
  /* If reduced motion, start already "in view" so nothing animates */
  const [inView, setInView] = useState(prefersReducedMotion);

  useEffect(() => {
    if (prefersReducedMotion) return;
    const el = ref.current;
    if (!el) return;

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setInView(true);
          observer.disconnect(); // animate once only
        }
      },
      { threshold }
    );

    observer.observe(el);
    return () => observer.disconnect();
  }, [threshold]);

  return [ref, inView];
};

export default useInView;
